import { store } from 'redux/store';
import { useCallback, useEffect, useState } from 'react';

import { getOperations } from '../redux/operationActions';

type UseGetOperationsProps = {
  societyId?: string;
  page?: number;
  rowsPerPage?: number;
  filters?: string[];
  refetchKey?: number;
};

export const useGetOperations = ({
  societyId,
  page = 1,
  rowsPerPage = 10,
  filters = [],
  refetchKey = 0,
}: UseGetOperationsProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const fetchOperations = useCallback(
    async (controller: AbortController) => {
      if (!societyId) return;

      try {
        setIsLoading(true);

        await store.dispatch(
          getOperations({
            societyId,
            params: {
              page,
              items: rowsPerPage,
              operationTypes: filters,
            },
            signal: controller.signal,
          })
        );

        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          setIsLoading(false);
          setIsError(true);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filters, page, rowsPerPage, societyId, refetchKey]
  );

  useEffect(() => {
    const controller = new AbortController();

    fetchOperations(controller);

    return () => controller.abort();
  }, [fetchOperations]);

  return {
    isLoading,
    isError,
  };
};
